import { SeoData, HeaderImage } from "components";
import { Link } from "react-router";
import styles from '../Home.module.css';

export const PostYourEvent = () => {
    return (
        <div className="standardContainer">
            <SeoData
                title={"Post Your Event"}
                description="Find out how you can promote your esports league, LAN, tournament, or wager site for free with uSync. Sign up today."
                canonicalPath={"/more/eventhost"}
            />
            <HeaderImage title={"Post Your Event"} imageClass={"gamesPage"} />
            
            <div className={`${styles.subscriptionContainer} ${styles.post}`}>
                <iframe 
                    src="https://docs.google.com/forms/d/e/1FAIpQLSf8UhB2bn7wDN9mHTpEfFvlLN9ZkDA47uWfUaAInWujsuez2g/viewform?embedded=true"
                    // width={"640"}
                    height={"1950"}
                    frameBorder="0"
                    marginheight="0"
                    marginwidth="0"
                    title="Event Post Form"
                    className="googleForm"
                />
            </div>

            <div className="hr" />

            <div className={styles.subscriptionContainer}>
                <p className={`${styles.learn} ${styles.post}`}>
                    Already Featured? Become {" "}
                    <Link to={"/more/verification"}>Verified</Link>
                </p>
            </div>
        </div>
    );
}
